/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Container,
  Image,
  Navbar,
  Nav,
  Spinner,
  Button,
} from "react-bootstrap";
import { Icon } from "components";

import { apiauth } from "services/api";
import { LOGO_KEY, USER_MENU, login, getUser, getToken } from "store/auth";

import "./styles.css";
//Dominos
import logo from "assets/dominos.svg";
// import colors from "layouts/colors";

const stContainer = {
  //Dominos
  background: "#006491",
  width: "256px",

  //Outros
  // background: "#fff",
  height: "100vh",
};

const stToggle = {
  border: 0,
  marginTop: 8,
  marginBottom: 8,
  fontSize: 12,

  //Dominos
  background: "#006491",
  color: "#FFFFFF",

  //Outros
  // background: "#FFFFFF",
  // color: "#03496F",
  width: "100%",
};

const stNavLink = {
  border: 0,
  marginLeft: 24,
  fontSize: 12,

  //Dominos
  color: "#FFFFFF",

  //Outros
  // color: "#03496F",
};

const stSpinner = {
  //Dominos
  color: "#FFFFFF",

  //Outros
  // color: "#03496F",
};

const NavBar = () => {
  const [menus, setMenus] = useState([]);
  const [imgLogo, setImgLogo] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const getMenus = async () => {
    try {
      setIsLoading(true);

      if (!getLocalMenus()) {
        // Caso não existam os menus localmente busca no endpoint
        const response = await apiauth().get("/menus/list");

        setMenus(response.data);
        setLocalMenus(response.data);
      } else {
        // Caso exitam os menus localmente são carregados do localStorage
        setMenus(getLocalMenus());
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getImages = async () => {
    setImgLogo(localStorage.getItem(LOGO_KEY));
  };

  useEffect(() => {
    const updateUser = async () => {
      try {
        const user = await getUser();
        const token = await getToken();

        //Pega os dados atualizados do usuário logado
        const respClone = await apiauth().get(`/sessions/clone/${user.id}`);
        // Pega os dados atualizados do menu do usuário logado
        const respMenu = await apiauth().get("/menus/list");

        login(respClone.data.dataUser, token, respClone.data.permissions);

        if (JSON.stringify(getLocalMenus()) !== JSON.stringify(respMenu.data)) {
          setMenus(respMenu.data);
          setLocalMenus(respMenu.data);
        }
      } catch (errors) {}
    };

    getMenus();
    getImages();

    const interval = setInterval(() => {
      updateUser();
    }, 600000); // roda a cada 10 minutos
    // }, 6000); // roda a cada 1 minuto
    return () => clearInterval(interval);
  }, []);

  const getLocalMenus = () => {
    const localMenus = JSON.parse(localStorage.getItem(USER_MENU));
    const sessionMenus = JSON.parse(sessionStorage.getItem(USER_MENU));

    if (localMenus) {
      return localMenus;
    } else {
      return sessionMenus;
    }
  };

  const setLocalMenus = (menu) => {
    localStorage.setItem(USER_MENU, JSON.stringify(menu));
    sessionStorage.setItem(USER_MENU, JSON.stringify(menu));
  };

  return (
    <Container fluid style={stContainer}>
      <div className="dvContainer">
        <div className="dvLogo">
          <Image
            src={logo}
            // src={imgLogo}
            rounded
            style={{
              width: "100%",
              height: "100%",
            }}
          />
        </div>

        <hr style={{ width: "100%", marginTop: "-0.375rem" }} />

        {isLoading ? (
          <div className="dvLoading">
            <Spinner animation="border" style={stSpinner} />
          </div>
        ) : (
          <div className="dvContent">
            {menus.map((item, idxItem) =>
              item.children ? (
                <Navbar expand="false" key={idxItem} style={{ padding: 0 }}>
                  <Navbar.Toggle
                    aria-controls="navbar-toggle"
                    className="btn btn-light"
                    style={stToggle}
                  >
                    <div className="dvMenu">
                      <div className="dvIconTitle">
                        <Icon name={item.iconName} style={{ marginRight: 8 }} />
                        {item.title}
                      </div>

                      <Icon
                        name="keyboard_arrow_down"
                        style={{ marginLeft: 8 }}
                      />
                    </div>
                  </Navbar.Toggle>

                  <Navbar.Collapse id="navbar-toggle">
                    {item.children.map((child, idxChildren) => (
                      <Nav.Link
                        key={idxChildren}
                        href={child.href}
                        style={stNavLink}
                      >
                        <div className="dvIconTitle">
                          <Icon
                            name={child.iconName}
                            style={{ marginRight: 8 }}
                          />
                          {child.title}
                        </div>
                      </Nav.Link>
                    ))}
                  </Navbar.Collapse>
                </Navbar>
              ) : (
                <Button
                  key={idxItem}
                  className="navbar-toggler"
                  style={stToggle}
                  variant="light"
                  href={item.href}
                >
                  <div className="dvMenu">
                    <div className="dvIconTitle">
                      <Icon name={item.iconName} style={{ marginRight: 8 }} />
                      {item.title}
                    </div>
                  </div>
                </Button>
              )
            )}
          </div>
        )}
      </div>
    </Container>
  );
};

export default NavBar;
